module.exports = "<header>\n  <h1>{{ $ctrl.title }}</h1>\n  <div>\n    <ng-transclude></ng-transclude>\n  </div>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/components/loansHeader/loansHeader.html
// module id = 2150
// module chunks = 0